<template>
  <div>
    <v-menu
      right
      transition="slide-x-transition"
      :close-on-content-click="false"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          dark
          v-bind="attrs"
          icon
          v-on="on"
        >
          <v-icon color="primary">
            mdi-server-network
          </v-icon>
        </v-btn>
      </template>

      <v-card>
        <v-col>
          <v-text-field
            v-model.trim="searchVal"
            append-icon="mdi-magnify"
            placeholder="Search version"
            single-line
            clearable
            outlined
            hide-details
            dense
            autofocus
          />
        </v-col>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: "FilterList",
  props: {
    posVersion: {
      type: String,
      default: ""
    }
  },
  computed: {
    searchVal: {
      get() {
        return this.searchText;
      },
      set(val) {
        this.$emit("search", val);
      }
    }
  }
};
</script>